import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-down', 'ChevronDown', [["path",{"d":"m6 9 6 6 6-6","key":"svg-0"}]]);